// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-modal-info {
  height: 100vh;
  position: relative;
  background: #faf7f6;
}

.slide-col {
  top: 0;
  bottom: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-size: 100% 30vh !important;
  overflow: auto;
}
.slide-col .image-full-screen {
  display: none;
}

.back-btn {
  position: absolute;
  top: 15px;
  left: 15px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.header-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 2;
  padding: 20px;
  padding-bottom: 0px;
  align-items: center;
}
.header-wrapper .back_btn {
  width: 30px;
  height: 30px;
}
@media (min-width: 991px) {
  .header-wrapper .back_btn {
    display: none;
  }
}

.option-group-col {
  flex-grow: 1;
  overflow: auto;
  flex-shrink: 1;
  flex-basis: auto;
  padding: 15px 20px;
}
.option-group-col.hidden {
  max-height: 0px;
  display: none;
}

.last-item {
  height: 75px;
}

.grow {
  flex-grow: 1;
  overflow: auto;
}

.back-img {
  position: absolute;
  top: 30px;
  left: 30px;
}

.image-wrapper {
  position: relative;
}
.image-wrapper .back_icon {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 99;
  zoom: 1.5;
}
.image-wrapper .cross_icon {
  z-index: 99;
  position: absolute;
  right: 10px;
  top: 10px;
  zoom: 1.5;
}

.main-img {
  height: 33vh;
  width: 100%;
  margin: 0 auto 0px;
}

.default-img {
  height: 15vh;
  width: 100px !important;
}

.info {
  padding: 20px 20px 0px 20px;
}
.info .title .info_block {
  font-size: 17px;
  margin-left: 5px;
  cursor: pointer;
}
.info .desc {
  line-height: 150%;
  margin-bottom: 20px;
  letter-spacing: 0.02em;
}
.info .notes-row {
  margin-top: 10px;
}
.info .notes-row .notes-textarea {
  --padding-start: 10px;
  --padding-end: 10px;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --highlight-color-focused: #fff!important;
  --highlight-color: #fff!important;
  caret-color: #fff;
  border-radius: 8px;
  border: 1px solid var(--accent-color);
}
.info .ingrediants-section {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0px;
  align-items: center;
  width: 100%;
}
.info .ingrediants-section h3 {
  text-align: left;
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-secondary);
}
.info .ingrediants-section p {
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-primary);
  text-decoration: underline;
}
@media (max-width: 992px) {
  .info .ingrediants-section p {
    width: 50%;
    text-align: right;
  }
}

.menge {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 20px 20px;
}
.menge h5 {
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  text-transform: uppercase;
}

ion-button {
  position: relative;
}
ion-button .buuton-text {
  font-size: var(--modal-info-button-font-size);
  color: var(--color-black);
  margin-right: 0;
}
ion-button .button-icon {
  position: absolute;
  right: 5px;
  height: 34px;
  width: 34px;
}

ion-toolbar {
  height: 60px;
  display: flex;
  align-items: center;
  --background: var(--background-color);
}
ion-toolbar ion-title {
  font-weight: 100;
  padding-inline: unset !important;
  font-size: 16px;
  text-align: left;
  margin-left: 40px;
  font-family: AppFontBold, sans-serif;
}
ion-toolbar ion-button {
  --background: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --background-hover: transparent;
}
ion-toolbar ion-icon {
  padding: 8px;
  font-size: 15px;
}

.option-group-description {
  padding: 10px 25px 0px 20px;
  text-align: left;
}

swiper-container {
  width: 100% !important;
  height: 100% !important;
}

swiper-slide {
  width: 100% !important;
}

ion-page {
  background: transparent;
}

.slider-select-half {
  height: 100%;
  width: 100%;
}

.separator {
  height: 14px;
  width: 100%;
}

.allergens {
  margin: 5px 20px;
}
.allergens app-accordion-list {
  width: 100%;
}

.padding-block {
  padding: 0px 20px;
}

.vertical-line {
  content: " ";
  width: 1px;
  height: 20px;
  color: white;
  background: white;
  margin-inline: 10px;
}

.add-background {
  background-size: cover;
}

.button-footer-block {
  margin: 0px !important;
  background: var(--ion-color-black);
  padding: 15px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  z-index: 999;
  font-size: 14px;
  border-top: 1px solid var(--color-black);
}

.center-element {
  display: flex;
  align-items: center;
  justify-content: center;
}

.style-block {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 130px;
}

@keyframes pulseColor {
  0% {
    color: var(--ion-color-primary);
  }
  30% {
    color: var(--color-black);
  }
  60% {
    color: var(--ion-color-primary);
  }
  100% {
    color: var(--color-black);
  }
}
.show-option-groups {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
}
.show-option-groups h1 {
  text-transform: uppercase;
  padding: 10px 20px;
}
.show-option-groups.error-item h1 {
  color: var(--color-black);
  animation: pulseColor 4s infinite alternate;
  text-transform: uppercase;
}
.show-option-groups ion-icon {
  transition: rotate 0.3s ease-in-out;
  margin-right: 20px;
  width: 15px;
  height: 15px;
}
.show-option-groups ion-icon.isOpen {
  rotate: 180deg;
}

.delete-option {
  position: absolute;
  bottom: -1px;
  right: 0%;
  z-index: 99;
  color: black;
  background: white;
  border-top-left-radius: 15px;
  text-align: center;
  padding: 7px;
  border-top: 2px dotted black;
  border-left: 2px dotted black;
}
.delete-option p {
  font-size: 13px;
  font-family: "AppFontBold";
  text-transform: uppercase;
  color: var(--ion-color-primary);
}

.vegan-block {
  display: flex;
  align-items: center;
}
.vegan-block ion-img {
  width: 35px;
  height: 24px;
}
.vegan-block p {
  text-transform: capitalize;
  margin-right: 5px;
  font-size: 12px;
  color: var(--ion-color-secondary);
}

.input-notes {
  padding: 20px;
  border-top: 1px solid var(--color-black);
}
.input-notes ion-item {
  border: 0.5px solid var(--color-black);
  border-radius: 26px;
  --background: #F6F1EF;
  margin-bottom: 10px;
  margin-top: 10px;
}
.input-notes .container {
  position: relative;
}
.input-notes .container ion-label {
  font-family: AppFont, sans-serif;
  font-weight: bold;
  font-size: 14px;
  padding: 0px 10px 10px 10px;
  color: var(--color-black);
}

.filters {
  width: 100%;
}
.filters app-menu-list-filters {
  width: 100%;
}

.text-block {
  margin-bottom: auto;
  margin-top: auto;
}

.price-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.price-row .price {
  font-family: AppFontBold;
  font-size: 14px;
  letter-spacing: 0;
  text-align: center;
  text-transform: uppercase;
}
.price-row .kcall {
  position: relative;
  font-size: 14px;
  line-height: 16.8px;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
}
.price-row .kcall,
.price-row .tags {
  position: relative;
  height: 17px;
  margin-left: 12px;
}
.price-row .kcall::before,
.price-row .tags::before {
  content: "";
  position: absolute;
  left: -6px;
  width: 1.5px;
  height: 100%;
  background: var(--color-black);
}

ion-textarea.custom {
  font-family: AppFont, sans-serif;
  color: var(--color-black);
  --border-width: 0;
}

.quantity-selector {
  display: flex;
  align-items: center;
}
.quantity-selector .quantity {
  margin: 0 12px;
}
.quantity-selector ion-icon {
  width: 32px;
  height: 32px;
  background-color: #fff;
  border-radius: 4px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-info/modal-info.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;AADF;;AAIA;EACE,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,cAAA;AADF;AAGE;EACE,aAAA;AADJ;;AA8CA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AA3CF;;AA8CA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AA3CF;AA6CE;EACE,WAAA;EACA,YAAA;AA3CJ;ACxCE;EDiFA;IAII,aAAA;EAzCJ;AACF;;AA8CA;EACE,YAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AA3CF;AA6CE;EACE,eAAA;EACA,aAAA;AA3CJ;;AAgDA;EACE,YAAA;AA7CF;;AAgDA;EACE,YAAA;EACA,cAAA;AA7CF;;AAgDA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AA7CF;;AAgDA;EAGE,kBAAA;AA/CF;AAiDE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;AA/CJ;AAkDE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AAhDJ;;AAoDA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAjDF;;AAqDA;EACE,YAAA;EACA,uBAAA;AAlDF;;AAqDA;EAEE,2BAAA;AAnDF;AAsDI;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AApDN;AAwDE;EACE,iBAAA;EACA,mBAAA;EACA,sBAAA;AAtDJ;AAyDE;EACE,gBAAA;AAvDJ;AAyDI;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yCAAA;EACA,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,qCAAA;AAvDN;AA2DE;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AAzDJ;AA2DI;EACE,gBAAA;EACA,eAAA;EACA,oCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,iCAAA;AA1DN;AA6DI;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,+BAAA;EACA,0BAAA;AA5DN;ACpJE;EDuME;IAWI,UAAA;IACA,iBAAA;EA1DN;AACF;;AAgEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EAQA,qBAAA;AApEF;AA8DE;EACE,oCAAA;EACA,eAAA;EACA,yBAAA;AA5DJ;;AAmEA;EACE,kBAAA;AAhEF;AAkEE;EACE,6CAAA;EACA,yBAAA;EACA,eAAA;AAhEJ;AAmEE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAjEJ;;AAqEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;AAlEF;AAoEE;EACE,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;AAlEJ;AAqEE;EACE,yBAAA;EACA,mCAAA;EACA,iCAAA;EACA,+BAAA;AAnEJ;AAsEE;EACE,YAAA;EACA,eAAA;AApEJ;;AAwEA;EACE,2BAAA;EACA,gBAAA;AArEF;;AAwEA;EACE,sBAAA;EACA,uBAAA;AArEF;;AAyEA;EACE,sBAAA;AAtEF;;AAyEA;EACE,uBAAA;AAtEF;;AAyEA;EACE,YAAA;EACA,WAAA;AAtEF;;AAyEA;EACE,YAAA;EACA,WAAA;AAtEF;;AAgFA;EACE,gBAAA;AA7EF;AA+EE;EACE,WAAA;AA7EJ;;AAiFA;EACE,iBAAA;AA9EF;;AAiFA;EACE,YAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AA9EF;;AAiFA;EAEE,sBAAA;AA/EF;;AAkFA;EACE,sBAAA;EACA,kCAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,wCAAA;AA/EF;;AAoFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAjFF;;AAoFA;EACE,YAAA;EACA,gBAAA;EACA,qBAAA;AAjFF;;AAoFA;EACE;IACE,+BAAA;EAjFF;EAmFA;IACE,yBAAA;EAjFF;EAmFA;IACE,+BAAA;EAjFF;EAmFA;IACE,yBAAA;EAjFF;AACF;AAqFA;EAEE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AApFF;AAsFE;EACE,yBAAA;EACA,kBAAA;AApFJ;AAwFI;EACE,yBAAA;EACA,2CAAA;EACA,yBAAA;AAtFN;AA0FE;EACE,mCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAxFJ;AA0FI;EACE,cAAA;AAxFN;;AA6FA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;AA1FF;AA4FE;EACE,eAAA;EACA,0BAAA;EACA,yBAAA;EACA,+BAAA;AA1FJ;;AA8FA;EACE,aAAA;EACA,mBAAA;AA3FF;AA6FE;EACE,WAAA;EACA,YAAA;AA3FJ;AA8FE;EACE,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,iCAAA;AA5FJ;;AAgGA;EACE,aAAA;EACA,wCAAA;AA7FF;AA+FE;EACE,sCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AA7FJ;AAiGE;EACE,kBAAA;AA/FJ;AAiGI;EAEE,gCAAA;EACA,iBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;AAhGN;;AAsGA;EACE,WAAA;AAnGF;AAqGE;EACE,WAAA;AAnGJ;;AAuGA;EACE,mBAAA;EACA,gBAAA;AApGF;;AAuGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,mBAAA;AArGF;AAuGE;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AArGJ;AAyGE;EACE,kBAAA;EAEA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAxGJ;AA2GE;;EAEE,kBAAA;EACA,YAAA;EACA,iBAAA;AAzGJ;AA4GE;;EAEE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;AA1GJ;;AA8GA;EACE,gCAAA;EACA,yBAAA;EACA,iBAAA;AA3GF;;AA8GA;EACE,aAAA;EACA,mBAAA;AA3GF;AA6GE;EACE,cAAA;AA3GJ;AA8GE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AA5GJ","sourcesContent":["@import \"../../../theme/mixins\";\n\napp-modal-info {\n  height: 100vh;\n  position: relative;\n  background: #faf7f6;\n}\n\n.slide-col {\n  top: 0;\n  bottom: 0;\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  background-size: 100% 30vh !important;\n  overflow: auto;\n\n  .image-full-screen {\n    display: none;\n\n  }\n\n  //@include desktop {\n  //  display: flex;\n  //  justify-content: space-between;\n  //  flex-wrap: nowrap;\n  //  flex-direction: row-reverse;\n  //  .image-full-screen {\n  //    width: 55%;\n  //    height: 100%;\n  //    display: flex;\n  //    align-items: center;\n  //    justify-content: center;\n  //    .image-wrapper {\n  //      width: 100%;\n  //      height: 100%;\n  //      display: flex;\n  //      align-self: center;\n  //      justify-content: center;\n  //      .block-item {\n  //        display: flex;\n  //        align-self: center;\n  //        justify-content: center;\n  //        width: 100%;\n  //      }\n  //      .main-img {\n  //        width: 50% !important;\n  //        height: 50% !important;\n  //        &.is-own-bowl {\n  //          width: 80% !important;\n  //          height: 80% !important;\n  //        }\n  //      }\n  //    }\n  //  }\n  //  .left-part-desktop {\n  //    width: 45%;\n  //    border-right: 1px solid var(--color-black);\n  //  }\n  //\n  //}\n}\n\n.back-btn {\n  position: absolute;\n  top: 15px;\n  left: 15px;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.header-wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  z-index: 2;\n  padding: 20px;\n  padding-bottom: 0px;\n  align-items: center;\n\n  .back_btn {\n    width: 30px;\n    height: 30px;\n    @include desktop {\n      display: none;\n    }\n  }\n\n}\n\n.option-group-col {\n  flex-grow: 1;\n  overflow: auto;\n  flex-shrink: 1;\n  flex-basis: auto;\n  padding: 15px 20px;\n\n  &.hidden {\n    max-height: 0px;\n    display: none;\n  }\n\n}\n\n.last-item {\n  height: 75px;\n}\n\n.grow {\n  flex-grow: 1;\n  overflow: auto;\n}\n\n.back-img {\n  position: absolute;\n  top: 30px;\n  left: 30px;\n}\n\n.image-wrapper {\n\n  // background: black url('../../../assets/losteria/modal-info.png') no-repeat center center / 100% 100%;\n  position: relative;\n\n  .back_icon {\n    position: absolute;\n    left: 10px;\n    top: 10px;\n    z-index: 99;\n    zoom: 1.5;\n  }\n\n  .cross_icon {\n    z-index: 99;\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    zoom: 1.5;\n  }\n}\n\n.main-img {\n  height: 33vh;\n  width: 100%;\n  margin: 0 auto 0px;\n\n}\n\n.default-img {\n  height: 15vh;\n  width: 100px !important;\n}\n\n.info {\n\n  padding: 20px 20px 0px 20px;\n\n  .title {\n    .info_block {\n      font-size: 17px;\n      margin-left: 5px;\n      cursor: pointer;\n    }\n  }\n\n  .desc {\n    line-height: 150%;\n    margin-bottom: 20px;\n    letter-spacing: 0.02em;\n  }\n\n  .notes-row {\n    margin-top: 10px;\n\n    .notes-textarea {\n      --padding-start: 10px;\n      --padding-end: 10px;\n      --padding-top: 8px;\n      --padding-bottom: 8px;\n      --highlight-color-focused: #fff!important;\n      --highlight-color: #fff!important;\n      caret-color: #fff;\n      border-radius: 8px;\n      border: 1px solid var(--accent-color);\n    }\n  }\n\n  .ingrediants-section {\n    display: flex;\n    justify-content: flex-end;\n    padding: 10px 0px;\n    align-items: center;\n    width: 100%;\n\n    h3 {\n      text-align: left;\n      font-size: 18px;\n      font-family: AppFontBold, sans-serif;\n\n      line-height: var(--modal-info-desc-line-height);\n      padding-bottom: 10px;\n      color: var(--ion-color-secondary);\n    }\n\n    p {\n      cursor: pointer;\n      text-align: left;\n      font-size: 16px;\n      font-family: AppFontBold, sans-serif;\n\n      line-height: var(--modal-info-desc-line-height);\n      padding-bottom: 10px;\n      color: var(--ion-color-primary);\n      text-decoration: underline;\n      @include mobile {\n        width: 50%;\n        text-align: right;\n      }\n\n    }\n  }\n}\n\n.menge {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  h5 {\n    font-family: AppFontBold, sans-serif;\n    font-size: 18px;\n    text-transform: uppercase;\n  }\n\n  margin: 0px 20px 20px;\n}\n\n\nion-button {\n  position: relative;\n\n  .buuton-text {\n    font-size: var(--modal-info-button-font-size);\n    color: var(--color-black);\n    margin-right: 0;\n  }\n\n  .button-icon {\n    position: absolute;\n    right: 5px;\n    height: 34px;\n    width: 34px;\n  }\n}\n\nion-toolbar {\n  height: 60px;\n  display: flex;\n  align-items: center;\n  --background: var(--background-color);\n\n  ion-title {\n    font-weight: 100;\n    padding-inline: unset !important;\n    font-size: 16px;\n    text-align: left;\n    margin-left: 40px;\n    font-family: AppFontBold, sans-serif;\n  }\n\n  ion-button {\n    --background: transparent;\n    --background-activated: transparent;\n    --background-focused: transparent;\n    --background-hover: transparent;\n  }\n\n  ion-icon {\n    padding: 8px;\n    font-size: 15px;\n  }\n}\n\n.option-group-description {\n  padding: 10px 25px 0px 20px;\n  text-align: left;\n}\n\nswiper-container {\n  width: 100% !important;\n  height: 100% !important;\n\n}\n\nswiper-slide {\n  width: 100% !important;\n}\n\nion-page {\n  background: transparent;\n}\n\n.slider-select-half {\n  height: 100%;\n  width: 100%;\n}\n\n.separator {\n  height: 14px;\n  width: 100%;\n  // background: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 100%;\n  //@include desktop {\n  //  // background: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 130%;\n  //  @media (max-height: 750px) {\n  //    height: 11px;\n  //  }\n  //}\n}\n\n.allergens {\n  margin: 5px 20px;\n\n  app-accordion-list {\n    width: 100%;\n  }\n}\n\n.padding-block {\n  padding: 0px 20px;\n}\n\n.vertical-line {\n  content: ' ';\n  width: 1px;\n  height: 20px;\n  color: white;\n  background: white;\n  margin-inline: 10px;\n}\n\n.add-background {\n  // background: black url(../../../assets/background/background.png)  no-repeat center center / 100% 100% !important;\n  background-size: cover;\n}\n\n.button-footer-block {\n  margin: 0px !important;\n  background: var(--ion-color-black);\n  padding: 15px;\n  position: fixed;\n  bottom: 0px;\n  left: 0px;\n  width: 100%;\n  z-index: 999;\n  font-size: 14px;\n  border-top: 1px solid var(--color-black);\n\n\n}\n\n.center-element {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.style-block {\n  height: 100%;\n  overflow-y: auto;\n  padding-bottom: 130px;\n}\n\n@keyframes pulseColor {\n  0% {\n    color: var(--ion-color-primary);\n  }\n  30% {\n    color: var(--color-black);\n  }\n  60% {\n    color: var(--ion-color-primary);\n  }\n  100% {\n    color: var(--color-black);\n\n  }\n}\n\n.show-option-groups {\n\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  justify-content: space-between;\n\n  h1 {\n    text-transform: uppercase;\n    padding: 10px 20px;\n  }\n\n  &.error-item {\n    h1 {\n      color: var(--color-black);\n      animation: pulseColor 4s infinite alternate;\n      text-transform: uppercase;\n    }\n  }\n\n  ion-icon {\n    transition: rotate 0.3s ease-in-out;\n    margin-right: 20px;\n    width: 15px;\n    height: 15px;\n\n    &.isOpen {\n      rotate: 180deg;\n    }\n  }\n}\n\n.delete-option {\n  position: absolute;\n  bottom: -1px;\n  right: 0%;\n  z-index: 99;\n  color: black;\n  background: white;\n  border-top-left-radius: 15px;\n  text-align: center;\n  padding: 7px;\n  border-top: 2px dotted black;\n  border-left: 2px dotted black;\n\n  p {\n    font-size: 13px;\n    font-family: 'AppFontBold';\n    text-transform: uppercase;\n    color: var(--ion-color-primary);\n  }\n}\n\n.vegan-block {\n  display: flex;\n  align-items: center;\n\n  ion-img {\n    width: 35px;\n    height: 24px;\n  }\n\n  p {\n    text-transform: capitalize;\n    margin-right: 5px;\n    font-size: 12px;\n    color: var(--ion-color-secondary);\n  }\n}\n\n.input-notes {\n  padding: 20px;\n  border-top: 1px solid var(--color-black);\n\n  ion-item {\n    border: 0.5px solid var(--color-black);\n    border-radius: 26px;\n    --background: #F6F1EF;\n    margin-bottom: 10px;\n    margin-top: 10px;\n\n  }\n\n  .container {\n    position: relative;\n\n    ion-label {\n\n      font-family: AppFont, sans-serif;\n      font-weight: bold;\n      font-size: 14px;\n      padding: 0px 10px 10px 10px;\n      color: var(--color-black);\n    }\n  }\n\n}\n\n.filters {\n  width: 100%;\n\n  app-menu-list-filters {\n    width: 100%;\n  }\n}\n\n.text-block {\n  margin-bottom: auto;\n  margin-top: auto;\n}\n\n.price-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  margin-bottom: 20px;\n\n  .price {\n    font-family: AppFontBold;\n    font-size: 14px;\n    letter-spacing: 0;\n    text-align: center;\n    text-transform: uppercase;\n\n  }\n\n  .kcall {\n    position: relative;\n\n    font-size: 14px;\n    line-height: 16.8px;\n    letter-spacing: 0%;\n    text-align: center;\n    text-transform: uppercase;\n  }\n\n  .kcall,\n  .tags {\n    position: relative;\n    height: 17px;\n    margin-left: 12px;\n  }\n\n  .kcall::before,\n  .tags::before {\n    content: '';\n    position: absolute;\n    left: -6px;\n    width: 1.5px;\n    height: 100%;\n    background: var(--color-black);\n  }\n}\n\nion-textarea.custom {\n  font-family: AppFont, sans-serif;\n  color: var(--color-black);\n  --border-width: 0;\n}\n\n.quantity-selector {\n  display: flex;\n  align-items: center;\n\n  .quantity {\n    margin: 0 12px;\n  }\n\n  ion-icon {\n    width: 32px;\n    height: 32px;\n    background-color: #fff;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
